export default {
  mission: {
    eyebrow: 'Who We Are',
    title: 'Vision, Mission & Values',
    vision: {
      title: 'Vision',
      subtitle: 'The world we want to create',
      label: 'Our Vision',
      text: 'A World where People are Well-connected, Transparently and Fairly.',
      imgAlt: 'Vision — Connecting Japan and the World',
    },
    mission: {
      title: 'Mission',
      subtitle: 'What we do to realize our vision',
      label: 'Our Mission',
      text: 'Develop talent that connects Japan and the world.',
      imgAlt: 'Our Mission — Developing talent connecting Japan and the world',
    },
    values: {
      title: 'Values',
      subtitle: 'The behavioral standards we uphold',
      imgAlt: 'Our Core Values',
      list: [
        { number: '01', title: 'Customer First', description: "Start with solving our customers' problems." },
        { number: '02', title: 'Speed Matters', description: 'Promote the importance of speed.' },
        { number: '03', title: 'Leadership & Ownership', description: 'Take ownership and demonstrate leadership.' },
        { number: '04', title: 'Ethical Innovation', description: 'Create innovation through wisdom and technology.' },
        { number: '05', title: 'Strength & Kindness', description: 'Combine strength with compassion.' },
        { number: '06', title: 'Clear Communication', description: 'Build trust through open and transparent communication.' },
      ],
    },
  },
};
